// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialCandidate = () => {
  const item = window.sessionStorage.getItem("candidate");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const getCandidate = createAsyncThunk(
  "candidate/getCandidate",
  async (obj, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_HR_API}candidates`, {
        params: { branch: obj.branch },
        headers: { Authorization: `Bearer ${obj.token}` },
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const candidateSlice = createSlice({
  name: "candidate",
  initialState: {
    candidateData: initialCandidate(),
  },

  extraReducers: (builder) => {
    builder
      .addCase(getCandidate.fulfilled, (state, action) => {
        state.candidateData = action.payload;
        sessionStorage.setItem("candidate", JSON.stringify(action.payload));
        // state.bookmarks = action.payload.bookmarks
      })
      .addCase(getCandidate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export default candidateSlice.reducer;
